import map from 'lodash/map'

export const getGraphLegendsColorId = (
  possibleIdentifiers: string[] | undefined,
  colors: string[]
) => {
  const res: { legend: string; color: string }[] = []
  map(possibleIdentifiers, (identifier, index) => {
    res.push({ legend: identifier, color: colors[index] })
  })
  return res
}
